// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tBTLdbE1Ud64OjbkAfgw {
  margin: 10px 0 10px 0;
}

.U6lyXTJNQ9QaiJUfrvAw {
  padding-bottom: 10px;
}

.HTS2BNre6gUOH1j3UUYV {
  position: relative;
  margin-bottom: 25px;
  background-color: white;
  min-height: 58px;
  box-shadow: rgba(63, 63, 68, 0.02) 0px 0px 0px 1px, rgba(63, 63, 68, 0.1) 0px 1px 3px, rgba(0, 0, 0, 0.02) 0px 1px 2px
}

.OBUNWbMBuqs7lPUhvkCw {
  border-bottom: 1px solid #D6D6D6;
  margin: 10px -20px;
}

.o6D8xxNoCnV1GtujoouW {
  border-bottom: 1px solid #D6D6D6;
  margin: 40px -20px;
}

.rS3iJdyE8QpOueB6DlY2 {
  padding: 0 20px 0 20px;
  margin: 10px -20px;
}

.TcKCmoqzKDIZjm_eSXKJ {
  display: none;
}

.hAJBrYVb1fJ0IJ5L82Td {
  width: 100%;
  height: 20px;
  margin: 20px 0;
}

.CRTBTEKaRYvgfgk1VBZE, .CRTBTEKaRYvgfgk1VBZE:hover, .CRTBTEKaRYvgfgk1VBZE:active, .CRTBTEKaRYvgfgk1VBZE:focus {
  background-color: #c5c5c5;
  border-color: #c5c5c5;
  color: white !important;
}

.xB_eKdRBSexHS6ghvn3P {
  margin-top: 20px;
}

.Sh7qsPenJUbglEOgP5oQ {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.atNIbdwtOETzqXES2CF4 {
  margin-bottom: 26px;
}

.jSpv3qnux7Qk5jBAHtEg {
  margin-bottom: 30px;
}

.p3Lmq3_OuyOxHOkbHuKz {
  margin-right:1rem;
}

.tOXSG1TtLGiWDsQ58vfG {
  margin-top:1rem;
}

.Wv22yVpbDEShddpR9VEE {
  color: #32445A;
  font-family: "Open Sans";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
}

.f6qD3As_JMNmvjAid6A9 {
  max-width:300px;
}

.MwuuxLgmcyJr2CctWy35 {
  display:flex;
  height: 100%;
  overflow:hidden;
  flex-direction: column;
}

.inJWW9DSFP6i15sRPUsW {
  margin-bottom: 21px;
  line-height: 19px;
  letter-spacing: 0;
  color: #32445A;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: bold;
}

.bZ_xlcMQbep4a5UjQRiX {
  display: flex;
  flex-direction: row;
  border-top: 1px solid #DCDCDC;
  border-bottom: 1px solid #DCDCDC;
  height:calc(100% - 66px - 46px);
}

.Y1IwPLbNpCy1bVad21cg {
  width:30%;
  padding:12px 22px;
  border-right: 1px solid #DCDCDC;
}

.l1Wt0GgYhVZQuAdRVsLO {
  width:70%;
  padding:12px 22px;
  height:100%;
}
.LfyM6Wxu7k5BFtyH85S1 {
  overflow: auto;
}

.mHHu5vVrzuiKqjLFtnkA {
  color: #32445A;
  font-family: "Open Sans";
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 18px;
  padding:22px 0;
  margin-right:1rem;
}

.xWVsbj0NYJerMbZnyEnP {
  display: flex;
  justify-content: flex-end;
  padding: 17px 29px;
  height: 85px;
}

.XIgnTBJSXNb8rv9UHMG1 {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/interests-batch-actions/batchActions.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB;AACF;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;AACf","sourcesContent":[".buttonBar {\n  margin: 10px 0 10px 0;\n}\n\n.skipContainer {\n  padding-bottom: 10px;\n}\n\n.subheader {\n  position: relative;\n  margin-bottom: 25px;\n  background-color: white;\n  min-height: 58px;\n  box-shadow: rgba(63, 63, 68, 0.02) 0px 0px 0px 1px, rgba(63, 63, 68, 0.1) 0px 1px 3px, rgba(0, 0, 0, 0.02) 0px 1px 2px\n}\n\n.dividerTop {\n  border-bottom: 1px solid #D6D6D6;\n  margin: 10px -20px;\n}\n\n.dividerBottom {\n  border-bottom: 1px solid #D6D6D6;\n  margin: 40px -20px;\n}\n\n.messageComponentWrapper {\n  padding: 0 20px 0 20px;\n  margin: 10px -20px;\n}\n\n.hidden {\n  display: none;\n}\n\n.addNoteDiv {\n  width: 100%;\n  height: 20px;\n  margin: 20px 0;\n}\n\n.buttonSecondaryColor, .buttonSecondaryColor:hover, .buttonSecondaryColor:active, .buttonSecondaryColor:focus {\n  background-color: #c5c5c5;\n  border-color: #c5c5c5;\n  color: white !important;\n}\n\n.activityFeedCard {\n  margin-top: 20px;\n}\n\n.messageInfoContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.templateSelectWrap {\n  margin-bottom: 26px;\n}\n\n.templateFormContainer {\n  margin-bottom: 30px;\n}\n\n.marginRight {\n  margin-right:1rem;\n}\n\n.marginTop {\n  margin-top:1rem;\n}\n\n.logCallPhones {\n  color: #32445A;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  letter-spacing: 0;\n  line-height: 18px;\n}\n\n.singleSelectRow {\n  max-width:300px;\n}\n\n.modalContainer {\n  display:flex;\n  height: 100%;\n  overflow:hidden;\n  flex-direction: column;\n}\n\n.modalHeading {\n  margin-bottom: 21px;\n  line-height: 19px;\n  letter-spacing: 0;\n  color: #32445A;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.contentWrap {\n  display: flex;\n  flex-direction: row;\n  border-top: 1px solid #DCDCDC;\n  border-bottom: 1px solid #DCDCDC;\n  height:calc(100% - 66px - 46px);\n}\n\n.tabsView {\n  width:30%;\n  padding:12px 22px;\n  border-right: 1px solid #DCDCDC;\n}\n\n.actionViews {\n  width:70%;\n  padding:12px 22px;\n  height:100%;\n}\n.actionViewsContent {\n  overflow: auto;\n}\n\n.actionViewLabel {\n  color: #32445A;\n  font-family: \"Open Sans\";\n  font-size: 15px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 18px;\n  padding:22px 0;\n  margin-right:1rem;\n}\n\n.modalFooter {\n  display: flex;\n  justify-content: flex-end;\n  padding: 17px 29px;\n  height: 85px;\n}\n\n.hideView {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonBar": `tBTLdbE1Ud64OjbkAfgw`,
	"skipContainer": `U6lyXTJNQ9QaiJUfrvAw`,
	"subheader": `HTS2BNre6gUOH1j3UUYV`,
	"dividerTop": `OBUNWbMBuqs7lPUhvkCw`,
	"dividerBottom": `o6D8xxNoCnV1GtujoouW`,
	"messageComponentWrapper": `rS3iJdyE8QpOueB6DlY2`,
	"hidden": `TcKCmoqzKDIZjm_eSXKJ`,
	"addNoteDiv": `hAJBrYVb1fJ0IJ5L82Td`,
	"buttonSecondaryColor": `CRTBTEKaRYvgfgk1VBZE`,
	"activityFeedCard": `xB_eKdRBSexHS6ghvn3P`,
	"messageInfoContainer": `Sh7qsPenJUbglEOgP5oQ`,
	"templateSelectWrap": `atNIbdwtOETzqXES2CF4`,
	"templateFormContainer": `jSpv3qnux7Qk5jBAHtEg`,
	"marginRight": `p3Lmq3_OuyOxHOkbHuKz`,
	"marginTop": `tOXSG1TtLGiWDsQ58vfG`,
	"logCallPhones": `Wv22yVpbDEShddpR9VEE`,
	"singleSelectRow": `f6qD3As_JMNmvjAid6A9`,
	"modalContainer": `MwuuxLgmcyJr2CctWy35`,
	"modalHeading": `inJWW9DSFP6i15sRPUsW`,
	"contentWrap": `bZ_xlcMQbep4a5UjQRiX`,
	"tabsView": `Y1IwPLbNpCy1bVad21cg`,
	"actionViews": `l1Wt0GgYhVZQuAdRVsLO`,
	"actionViewsContent": `LfyM6Wxu7k5BFtyH85S1`,
	"actionViewLabel": `mHHu5vVrzuiKqjLFtnkA`,
	"modalFooter": `xWVsbj0NYJerMbZnyEnP`,
	"hideView": `XIgnTBJSXNb8rv9UHMG1`
};
export default ___CSS_LOADER_EXPORT___;
